import React, { FC, useEffect, useState } from 'react';

import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalFooter
} from '@epoch-ui/components/Modal/modal';
import { Button } from '@epoch-ui/components/Button';
import AIGenerateIcon from 'components/common/icons/AIGenerateIcon';

import AIBetaPill from '../../AIBetaPill';

import EventDescriptionAISteps from './EventDescriptionAISteps';

interface EventDescriptionCommentsProps extends React.ComponentProps<typeof Modal> {
  handleSubmit: (comment: string) => void;
  handleBack: () => void;
  commentInput?: string;
}

/**
 * AI modal prompts for Event description.
 * step 3: Ask for any other comments that we shoul use.
 * @param param0
 * @returns
 */
const EventDescriptionComments: FC<React.PropsWithChildren<EventDescriptionCommentsProps>> = ({
  handleSubmit,
  handleBack,
  commentInput,
  open: isOpen,
  onOpenChange: onRequestClose,
  ...props
}) => {
  const [comment, setComment] = useState<string>();

  useEffect(() => {
    setComment(commentInput || '');
  }, [commentInput]);

  return (
    <Modal open={isOpen} onOpenChange={(open) => !open && onRequestClose?.(false)} {...props}>
      <ModalContent size="md" className="tw-max-w-[556px]">
        <ModalHeader>
          <div className="tw-flex tw-flex-col tw-items-start">
            <AIBetaPill />
            <ModalTitle>Suggest description</ModalTitle>
          </div>
        </ModalHeader>
        <div className="tw-text-sm tw-font-medium tw-text-dark-black">
          What else do you want us to include?
        </div>

        <textarea
          value={comment}
          onChange={(event: React.ChangeEvent<HTMLTextAreaElement>): void => {
            setComment(event.target.value);
          }}
          placeholder="For example, tell AI to write an agenda and include an FAQs section."
          className="tw-mt-3 tw-h-full tw-max-h-60 tw-min-h-18 tw-w-full tw-rounded-lg
         tw-border-solid tw-border-border-grey tw-p-4 focus:tw-outline focus:tw-outline-primary-blue"
        />

        <ModalFooter className="tw-justify-between sm:tw-justify-between">
          <EventDescriptionAISteps step={4} />
          <div className="tw-flex tw-gap-2">
            <Button variant="secondary" onClick={handleBack}>
              Back
            </Button>
            <Button
              variant="primary"
              disabled={!comment}
              onClick={(): void => {
                handleSubmit(comment!);
              }}
            >
              Generate
              <span className="tw-ml-2">
                <AIGenerateIcon color="white" />
              </span>
            </Button>
          </div>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EventDescriptionComments;
